<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('retailSale.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('retailSale.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <ts-button
            outline
            color="info"
            @click="$router.push({ name: 'retail-sale-create' })"
            >{{ $t('add_new') }}</ts-button
          >
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('invoice.filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="() => (visible = false)"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-select
                  style="width: 257px"
                  v-model="branch_id"
                  :options="branchs"
                  showSearch
                  mode="multiple"
                  :filterOption="
                    (input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                  "
                  :maxTagCount="1"
                  :maxTagTextLength="17"
                  :placeholder="$t('all')"
                >
                </a-select>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table :columns="columns" :records="resources" :loading="loading">
          <template v-slot="{ record }">
            <td>{{ record.branch.branch_name_en }}</td>
            <td>{{ record.stock_out_date }}</td>
            <td>{{ record.invoice_no }}</td>
            <td class="ts-whitespace-no-wrap">
              {{ record.student ? record.student.full_name_en : null }}
            </td>
            <td class="text-right">{{ record.vat_amount }}</td>
            <td class="text-right">{{ record.sub_total }}</td>
            <td class="text-right">{{ record.grand_total }}</td>
            <td class="text-center">
              {{
                record.payment_method
                  ? record.payment_method.payment_method
                  : ''
              }}
            </td>
            <td class="text-center">
              <p
                class="ts-font-semibold ts-text-blue-600"
                v-if="record.payment_method_id != 1"
              >
                {{
                  record.bank_account
                    ? record.bank_account.bankprofile
                      ? record.bank_account.bankprofile.bank_name
                      : ''
                    : ''
                }}
              </p>
              <p v-if="record.payment_method_id != 1">
                <span
                  class="ts-bg-gray-500 ts-px-1 ts-rounded-lg ts-text-white ts-text-xs"
                  >{{
                    record.bank_account
                      ? record.bank_account.bankprofile
                        ? record.bank_account.account_name +
                          '|' +
                          record.bank_account.account_number
                        : ''
                      : ''
                  }}</span
                >
              </p>
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              <a
                href="#"
                class="text-primary mr-2"
                @click.prevent="viewPdf(record)"
              >
                <i class="fa fa-print"></i>
              </a>
              <a href="#" class="text-primary" @click.prevent="edit(record)">
                <i class="fa fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin ml-2"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash ml-2 text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
      <a-modal
        v-model="pdfModal"
        :title="$t('pdf')"
        @cancel="() => (pdfModal = false)"
        width="35%"
        :maskClosable="false"
        :footer="null"
        :zIndex="1020"
      >
        <preview-pdf-component :src="src" :waiting="waiting" />
      </a-modal>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import PreviewPdfComponent from './components/pdf-preview'

export default {
  name: 'retailSale',
  components: {
    PreviewPdfComponent
  },
  data () {
    return {
      visible: false,
      rangeDate: [moment(), moment()],
      branchs: [],
      loading: false,
      pdfModal: false,
      waiting: false,
      src: null
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('retailSale', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.retailSale.search
      },
      set (newValue) {
        this.$store.commit('retailSale/SET_SEARCH', newValue)
        this.$store.commit('retailSale/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.retailSale.branch_id
      },
      set (newValue) {
        this.$store.commit('retailSale/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('retailSale.branchName') },
        { name: this.$t('retailSale.date') },
        { name: this.$t('retailSale.invoiceNumber') },
        { name: this.$t('retailSale.student') },
        { name: this.$t('retailSale.vatAmount'), style: 'text-align: right' },
        { name: this.$t('retailSale.subTotal'), style: 'text-align: right' },
        { name: this.$t('retailSale.grandTotal'), style: 'text-align: right' },
        {
          name: this.$t('retailSale.paymentMethod'),
          style: 'text-align: center'
        },
        { name: this.$t('retailSale.bank'), style: 'text-align: center' },
        { name: this.$t('actions'), style: 'text-align:center; width:7%' }
      ]
    }
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch(
          'retailSale/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    },
    dateRangeChange (dateRange) {
      this.$store.commit(
        'retailSale/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'retailSale/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    },
    viewPdf (row) {
      this.pdfModal = true
      this.waiting = true
      this.$store
        .dispatch('retailSale/pdf', row.stock_out_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    deleteRecord (record) {
      record._deleting = true
      this.$store
        .dispatch('retailSale/destroy', record.stock_out_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    },
    edit (record) {
      this.$store.commit('retailSale/SET_EDIT_DATA', record)
      this.$router.push({
        name: 'retail-sale-edit',
        params: { id: record.stock_out_id }
      })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500)
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('retailSale/RESET_STATE')
    next()
  }
}
</script>
